import axios from './config'


export const notification = async (data) => await axios.post('/b/p/notificator', data, {
  headers: {
    service: 'NOTIFICATOR'
  }
});
